'use client';
import React from 'react';
import '../globals.css';
import { Sidebar, WidgetCategoryLinks } from '../../components/Sidebar';
import { SiteHeader } from '../../components/SiteHeader';

export default function WidgetsLayout({ children }: { children: React.ReactNode }) {
    const [collapsed, setCollapsed] = React.useState(false);

    return (
        <div className="min-h-screen bg-surface-x10 text-text-x10">
            <SiteHeader menuExtra={<WidgetCategoryLinks />} />
            <div className="flex">
                <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
                <main className="mx-auto w-full min-w-0 max-w-6xl flex-1 px-6 py-10 wsm:px-8 wsm:py-12">
                    {children}
                </main>
            </div>
        </div>
    );
}
